import type React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SignUpSettingsModal from "~/components/Organization/signUpSettingModal";
import type { RootState } from "~/store";

const SignUp: React.FC = () => {
  const authState = useSelector((state: RootState) => state.auth) as any;
  const navigate = useNavigate();

  useEffect(() => {
    if (!authState || authState.signupAllowed !== true) {
      navigate("/");
    }
  }, [authState, navigate]);

  if (!authState || authState.signupAllowed !== true) {
    return null;
  }

  return (
    <div>
      <SignUpSettingsModal />
    </div>
  );
};

export default SignUp;
